@if (showRestrictions) {
  <table id="files-container-{{ namespace }}" class="table-full-width">
    <tr>
      <td class="header">
        {{ title }}
      </td>
    </tr>
    @if (showSourceEntityRestriction) {
      <tr>
        <td>
          <app-attachment-source-restriction
            [fileSection]="fileSection"
            [templateEntity]="_entityType"
            (attachmentSourceInitialised)="attachmentSourceInitialised()">
          </app-attachment-source-restriction>
        </td>
      </tr>
    }
    @if (showFileTypeRestrictions) {
      <tr>
        <td>
          <app-file-type-restrictions
            [fileSection]="fileSection"
            [namespace]="namespace"
            [entityTypes]="sourceEntitiesLeafs"
            [valid]="valid"
            [outputFileType]="outputFileType"
            [documentTypes]="documentTypes"
            [expandUp]="expandUp"
          ></app-file-type-restrictions>
        </td>
      </tr>
    }
    @if (showFileAgeRestriction) {
      <tr>
        <td>
          <app-file-age-restriction [fileSection]="fileSection"></app-file-age-restriction>
        </td>
      </tr>
    }
  </table>
}
